<template>
  <div
    class="preview-schedule-relative"
    v-if="loading == false && status == false"
  >
    <img :src="image" alt="" />
  </div>

  <div class="eventSchedule" v-else-if="loading == false && status == true">
    <HeaderInPreview :isPreview="isPreview" :data="m_event" />
    <div class="eventDescription">
      <div class="brief">
        <div class="content">
          <div
            class="sub-content"
            v-if="eventScheduleNote && eventScheduleNote.event_schedule_note"
            v-html="eventScheduleNote.event_schedule_note"
          ></div>
          <div class="sub-content" v-else>{{ noDataText }}</div>
        </div>
      </div>
    </div>
    <div
      class="listSchedule"
      v-if="eventScheduleDate && eventScheduleDate.length > 0"
    >
      <v-tabs
        background-color="transparent"
        color="#fff"
        class="tab-header"
        v-if="eventScheduleDate"
      >
        <v-tab
          v-for="date in eventScheduleDate"
          :key="date.id"
          @click="getEventSchedule(date.id, roomId)"
        >
          <v-icon dark left>mdi-calendar</v-icon>
          <div class="header-title">
            {{ formatDate(date.event_schedule_date) }}
          </div>
        </v-tab>
      </v-tabs>
      <div class="brief" v-if="eventScheduleDate.length > 0">
        <v-tabs
          color="#333"
          class="room-tabs"
          v-if="eventScheduleDate && eventScheduleRoom.length > 0"
        >
          <v-tab
            v-for="room in eventScheduleRoom"
            :key="room.id"
            @click="getEventSchedule(dateId, room.id)"
          >
            <div class="header-title">{{ room.event_schedule_room }}</div>
          </v-tab>
        </v-tabs>

        <div
          class="tab-content"
          v-for="section in eventScheduleSection"
          :key="section.id"
        >
          <p class="table-header">{{ section.event_schedule_section }}</p>
          <div class="table-wrapper">
            <v-data-table
              :headers="headers"
              :items="section.scheduleArr"
              hide-default-footer
              disable-pagination
              class="elevation-1 app_table"
              :no-data-text="noDataText"
              mobile-breakpoint="0"
            >
              <template v-slot:item="{ item }">
                <tr
                  :class="item.is_top ? 'schedule-top' : 'schedule-top-child'"
                >
                  <td class="schedule-time">
                    <span class="row-center">
                      <v-icon
                        size="18px"
                        class="btn_item mr-1"
                        v-if="item.is_top"
                      >
                        {{ clockIcon }}
                      </v-icon>

                      <span>
                        {{
                          item.is_top
                            ? getTimeToTime(
                                item.event_schedule_time_from,
                                item.event_schedule_time_to,
                                item.event_schedule_date
                              )
                            : ''
                        }}
                      </span>
                    </span>
                  </td>
                  <td class="schedule-content">
                    {{ item.is_top ? item.event_schedule_content : '' }}
                  </td>
                  <td class="schedule-name">
                    <a
                      :href="item.url"
                      target="_blank"
                      :class="
                        item.url ? 'link-schedule' : 'link-schedule text-black'
                      "
                    >
                      {{ item.company_name }}
                    </a>
                  </td>

                  <td class="schedule-note">
                    {{ item.note }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>

      <div class="brief" v-else>
        {{ noDataText }}
      </div>
    </div>

    <ScrollTopBtn />
  </div>

  <div class="landingPage landing-relative" v-else>
    <img :src="loadingImage" alt="test-data" />
  </div>
</template>
<script>
import { mdiClockOutline } from '@mdi/js';
import ScrollTopBtn from '@/components/ScrollTopBtn';
import { LANG_CODE_JAPANESE } from '@/common/constants';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import LoadingGif from '@/assets/image/loading.gif';
import HeaderInPreview from '@/components/HeaderInPreview';
export default {
  data() {
    return {
      isPreview: false,
      dateId: '',
      roomId: '',
      clockIcon: mdiClockOutline,
      loading: true,
      status: false,
      loadingImage: LoadingGif,
      image:
        'https://cdn.dribbble.com/users/215588/screenshots/909046/oops.png',
      headers: [
        {
          text: this.$t('event-schedule-page.table-header.time', {
            split: '/'
          }),
          value: 'event_schedule_time_from',
          align: 'start',
          sortable: false
        },
        {
          text: this.$t('event-schedule-page.table-header.content', {
            split: '/'
          }),
          value: 'event_schedule_content',
          align: 'start',
          class: 'link-schedule',
          sortable: false
        },
        {
          text: this.$t('event-schedule-page.table-header.company-name', {
            split: '/'
          }),
          value: 'company_name',
          align: 'start',
          sortable: false
        },

        {
          text: this.$t('event-schedule-page.table-header.note', {
            split: '/'
          }),
          value: 'note',
          align: 'start',
          class: 'link-schedule',
          sortable: false
        }
      ],

      noDataText: this.$t('table-no-data', {
        split: '/'
      })
    };
  },
  components: {
    ScrollTopBtn,
    HeaderInPreview
  },
  methods: {
    alterText(text) {
      if (text != '') {
        return text.length > 40 ? text.substr(0, 40) + '...' : text;
      } else {
        return '';
      }
    },

    add24h(time) {
      const newHour = parseInt(time.split(':')[0]) + 24;

      const str = newHour + ':' + time.split(':')[1];

      return str;
    },

    getTimeToTime(fromData, toData, dateId) {
      const dateCheck = this.eventScheduleDate.find((ele) => ele.id == dateId);

      if (dateCheck) {
        const timeZoneFilter = this.c_time_zone.filter(
          (timezone) => timezone.id == this.m_event.time_zone
        );

        let dateFrom = '';
        let dateTo = '';

        if (timeZoneFilter.length > 0) {
          const dateFromCheck =
            moment
              .utc(fromData)
              .tz(timeZoneFilter[0].time_zone_code)
              .format('YYYY-MM-DD')
              .toString() ==
            moment
              .utc(dateCheck.event_schedule_date)
              .format('YYYY-MM-DD')
              .toString()
              ? true
              : false;

          const dateToCheck =
            moment
              .utc(toData)
              .tz(timeZoneFilter[0].time_zone_code)
              .format('YYYY-MM-DD')
              .toString() ==
            moment
              .utc(dateCheck.event_schedule_date)
              .format('YYYY-MM-DD')
              .toString()
              ? true
              : false;

          dateFrom = fromData
            ? !dateFromCheck
              ? this.add24h(
                  moment
                    .utc(fromData)
                    .tz(timeZoneFilter[0].time_zone_code)
                    .format('HH:mm')
                )
              : moment
                  .utc(fromData)
                  .tz(timeZoneFilter[0].time_zone_code)
                  .format('HH:mm')
            : '';

          dateTo = toData
            ? !dateToCheck
              ? this.add24h(
                  moment
                    .utc(toData)
                    .tz(timeZoneFilter[0].time_zone_code)
                    .format('HH:mm')
                )
              : moment
                  .utc(toData)
                  .tz(timeZoneFilter[0].time_zone_code)
                  .format('HH:mm')
            : '';
        }

        return dateFrom + ' ~ ' + dateTo;
      }
    },

    formatDate(date) {
      const dateString =
        this.$i18n.locale === LANG_CODE_JAPANESE
          ? moment(date).format('YYYY/MM/DD')
          : moment(date).format('DD/MM/YYYY');

      return dateString;
    },

    getEventSchedule(dateId, roomId) {
      if (dateId) {
        this.dateId = dateId;
      }

      this.roomId = roomId;

      if (this.dateId) {
        const data = {
          event_id: this.checkEvent.event_id,
          event_schedule_date_id: this.dateId,
          event_schedule_room_id: this.roomId
        };

        this.$store
          .dispatch('getEventScheduleByDateAndRoom', data)
          .then((res) => {
            this.dateId = res.dateId;
            this.roomId = res.roomId || null;
          });
      }
    },
    checkEventSchedule() {
      if (this.$route) {
        const { params } = this.$route;

        const data = {
          contract_id: params.contractID,
          event_code: params.eventID
        };
        this.loading = true;
        this.status = true;
        const fullPath = this.$route.fullPath;
        setTimeout(() => {
          this.$store
            .dispatch('getEventMaster', { data, fullPath })
            .then(() => {
              const { id } = this.eventMaster;
              this.$store
                .dispatch('getDataEventSchedulePreview', {
                  event_id: id
                })
                .then((status) => {
                  this.loading = false;
                });
            })
            .catch((error) => {
              this.status = false;
              this.loading = false;
            });
        }, 0);
      }
    }
  },

  created() {
    this.checkEventSchedule();
  },

  computed: {
    ...mapGetters({
      eventScheduleNote: 'getEventScheduleNote',
      eventScheduleDate: 'getEventScheduleDate',
      eventScheduleRoom: 'getEventScheduleRoom',
      eventScheduleSection: 'getEventScheduleSection',
      eventSchedule: 'getEventSchedule',
      hasEventScheduleRoomNullData: 'getHasEventScheduleRoomNullData',
      eventMaster: 'getEventData',
      applicant: 'getBasicInfomation'
    })
  },

  watch: {
    eventScheduleDate: function (val) {
      if (typeof val !== 'undefined') {
        return (this.dateId = val.length > 0 ? val[0].id : null);
      }
      return val;
    },

    eventScheduleRoom: function (val) {
      if (typeof val !== 'undefined') {
        return (this.roomId = val.length > 0 ? val[0].id : null);
      }
    },

    eventSchedule: function (val) {
      return val;
    },

    eventScheduleSection: function (val) {
      return val;
    },

    '$i18n.locale': function () {
      this.noDataText = this.$t('table-no-data', { split: '/' });

      this.headers = [
        {
          text: this.$t('event-schedule-page.table-header.time', {
            split: '/'
          }),
          value: 'event_schedule_time_from',
          align: 'start',
          sortable: false
        },
        {
          text: this.$t('event-schedule-page.table-header.content', {
            split: '/'
          }),
          value: 'event_schedule_content',
          align: 'start',
          class: 'link-schedule',
          sortable: false
        },
        {
          text: this.$t('event-schedule-page.table-header.company-name', {
            split: '/'
          }),
          value: 'company_name',
          align: 'start',
          sortable: false
        },
        {
          text: this.$t('event-schedule-page.table-header.note', {
            split: '/'
          }),
          value: 'note',
          align: 'start',
          class: 'link-schedule',
          sortable: false
        }
      ];
    }
  }
};
</script>
<style lang="scss">
@import '@/style/common.scss';
@import '@/style/devices.scss';
@import './eventSchedule.scss';
</style>
